import { Card, Col, Row, Button, message } from "antd";
import React, { useContext, useEffect, useState } from "react";
import "./dashboard.scss";
import join from "../../assets/join.png";
import follow from "../../assets/follow.svg";
import youtube from "../../assets/tube.svg";
import insta from "../../assets/insta.svg";
import linkdin from "../../assets/linkedin.svg";
import { CopyOutlined } from "@ant-design/icons";
import { Link, useOutletContext } from "react-router-dom";
import { ThemeContext } from "../../context/themeProvider";
import dashboardService from "../../services/dashboardService";
import { Modal } from "antd";
import EarnBaaiTokensModal from "./EarnBaaiTokensModal";

const ROOT = `dashboard_module`;


export default function ReferralBanner() {
  const data = useOutletContext();
  const [url, setUrl] = useState("");

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user-signup"));
    let link = "";
    if (data) {
      link =
        window.origin + "/" + data?.userProfile?.affiliateDetails?.referralCode;
    }
    if (user) {
      link = window.origin + "/" + user?.affiliateData?.referralCode;
    }
    setUrl(link);
  }, [data]);

  const copyReferral = (text) => {
    navigator.clipboard.writeText(text);
    message.destroy();
    message.info("Referral link copied");
  };




  // for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Card className={`${ROOT}__banner_ui`}>
        <Row gutter={[25, 25]}>
          <Col lg={12} xs={24}>
            <div className="banner_wrap">
              <h2>
                <span>ENGAGE</span> TO <span>EARN</span> !
              </h2>
              <h1>
                $50,000 <span>Reward Pool</span>
              </h1>
              <p>
                First 25K Users Will Be Rewarded!{" "}

              </p>
              <div style={{color:"white"}}><Button onClick={showModal} type="primary" size="medium">Start Earning</Button><Link
                to="https://medium.com/@BrainaliveAI/focii-chrome-extension-launch-win-rewards-worth-50-000-f4a6525b381a"
                target="_blank"
                style={{color:'white',textDecoration:'none', paddingLeft:"11px"}}
              >
                  Know More
              </Link></div>
              <div className={`${ROOT}__link_ui`} >
                <p>
                  Copy and share your referral link with your friends and family
                </p>
                <h5 className="text-truncate"> {url} <button
                  onClick={() => {
                    copyReferral(url);
                  }}
                  style={{ padding: "5px", backgroundColor: '#1677ff', color: 'white', border: 'none', borderRadius: '6px' }}
                >
                  <CopyOutlined />
                </button></h5>
                <div className="mt-3">


                  <p className="mt-2 btn_link">
                    Earn BAAI tokens for each referral
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col
            lg={12}
            xs={24}
            style={{ justifyContent: "center", display: "flex" }}
          >
            <Row align="middle">
              <Col lg={24}>
                <div className={`${ROOT}__rewards`}>
                  <h4>
                    Join us on our Socials, and stay updated <br />
                    with upcoming <span>BAAI Rewards & Airdrops</span>
                  </h4>
                  <div className="text-center mt-4 text-decoration-none btn_social">
                    <a href="https://twitter.com/BrainAlive_AI" target="blank">
                      {" "}
                      <img src={follow} alt="Join telegram" />
                    </a>
                    <a
                      className="text-decoration-none"
                      href="https://t.me/Braina_Live"
                      target="blank"
                      style={{ marginLeft: "20px" }}
                    >
                      {" "}
                      <img src={join} alt="Join telegram" />
                    </a>
                  </div>
                  <div className="text-center mt-3">
                    <a
                      className="text-decoration-none"
                      target="blank"
                      href="https://www.youtube.com/@brainaliveresearch7339"
                    >
                      {" "}
                      <img src={youtube} alt="Join telegram" />
                    </a>
                    <a
                      className="text-decoration-none"
                      href="https://www.instagram.com/brainalive_ai/"
                      target="blank"
                      style={{ margin: "0px 20px" }}
                    >
                      {" "}
                      <img src={insta} alt="Join telegram" />
                    </a>
                    <a
                      className="text-decoration-none"
                      href="https://www.linkedin.com/company/brainaliveai"
                      target="blank"
                    >
                      {" "}
                      <img src={linkdin} alt="Join telegram" />
                    </a>
                  </div>
                </div>

              </Col>
            </Row>
          </Col>
        </Row>
      </Card>

      {/* modals */}
      <Modal
        className="earn-baai-tokens-modal"
        centered
        footer={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <EarnBaaiTokensModal handleClose={handleCancel} />
      </Modal>


    </>
  );
}
